var params = {};
params.remedy_start = 2015;
params.app_name_long = "Remedy Benefits Illustrator";
params.app_name_short = "illustrator";
export default params;
